import { useQuery } from "react-query";
import { getOfficeApplianceBrand } from "../api/officeApplianceService";

export const useGetOfficeApplianceBrand = () => {
  return useQuery("OfficeApplianceBrand", getOfficeApplianceBrand, {
    refetchOnWindowFocus: false,
  });
};
